import { FormControl } from '@angular/forms';
export abstract class AbstractDto {
	hashCode!: number;
}
export abstract class AbstractDynamicDto extends AbstractDto {
	properties!: { [key: string]: string };
}
export class AgentDto extends AbstractDto {
	id?: number;
	createdAt?: Date;
	username?: string;
	password?: string;
	firstName?: string;
	lastName?: string;
	emailAddress?: string;
	msisdn?: string;
	status!: AgentStatusEnum;
	superUser!: boolean;
	roles!: AppRoleDto[];
	properties!: DynamicProperties;
}
export class AppRoleDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	name!: string;
	description!: string;
	permissions!: PermissionDto[];
	agents!: AgentLinkDto[];
}
export class PermissionDto extends AbstractDto {
	group!: RolePermissionGroupEnum;
	permission!: RolePermissionEnum;
	label!: string;
	description?: string;
	selected!: boolean;
}
export class LoginRequestDto {
	username?: string;
	password?: string;
	otp?: string;
}
export class LoginResponseDto extends AbstractDto {
	success?: boolean;
	message?: string;
	agent?: AgentDto;
	expiresIn?: number;
	jwtToken?: string;
}
export class ForgotPasswordResetResponseDto extends AbstractDto {
	result?: OtpLookupResultEnum;
	message?: string;
}
export class AuthenticationWrapper {
	expiresAt!: number;
	agent!: AgentDto;
	authToken!: string;
}


export class DynamicFormDto extends AbstractDto {
	id?: number;
	templateName!: string;
	elements!: DynamicFormElementDto[];
	entityType!: DynamicEntityTypeEnum;
	subForms!: { [key: string]: DynamicFormDto };  //Key is of type: DynamicEntityTypeEnum
	formControls?: { [id: number]: FormControl };
}
export class DynamicFormElementDto extends AbstractDto {
	id!: number;
	value?: Object | DynamicFormDto[];
	property!: string;
	dependencyId?: number;

	name!: string;
	description!: string;
	sectionName!: string;
	dependencyValue?: string;
	dataType!: DynamicValueDataTypeEnum;
	options?: DynamicFormOptionDto[];
	orderIndex!: number;
	icon?: string;
	activeOnCreate!: Boolean;
	activeOnUpdate!: Boolean;
	required!: Boolean;
	errorMessageRequired?: string;
	isUnique!: Boolean;
	errorMessageUnique?: string;
	regex?: string;
	errorMessageRegex?: string;
	minValue?: number;
	errorMessageMinValue?: string;
	maxValue?: number;
	errorMessageMaxValue?: string;
	subEntityType?: DynamicEntityTypeEnum;
}
export class DynamicFormOptionDto extends AbstractDto {
	value?: string;
	label!: string;
	orderIndex!: number;
}
export class DynamicPropertyDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	property!: string;
	name!: string;
	description?: string;
	bulkImportColumnName?: string;
	type!: DynamicTypeEnum;
	dependencyId?: number;
	sectionId!: number;
	orderIndex!: number;
	icon?: string;
	activeOnCreate!: Boolean;
	activeOnUpdate!: Boolean;
	searchable!: Boolean;
	dataType!: DynamicValueDataTypeEnum;
	isUnique!: Boolean;
	minValue?: number;
	maxValue?: number;
	required!: Boolean;
	regex?: string;
	dependencyValue?: string;
	options!: DynamicFormOptionDto[];
	errorMessageUnique?: string;
	errorMessageRequired?: string;
	errorMessageRegex?: string;
	errorMessageMinValue?: string;
	errorMessageMaxValue?: string;
	fieldDisabled!: boolean;
	subDynamic?: DynamicEntityDto;
}
export class DynamicEntityDto extends AbstractDto {
	id!: number;
	label!: string;
	description!: string;
	template!: DynamicTemplateDto;
	properties!: DynamicPropertyDto[];
	entityType!: DynamicEntityTypeEnum;
	subEntityTypes!: DynamicEntityTypeEnum[];
}
export class DynamicTemplateDto extends AbstractDto {
	id!: number;
	name!: string;
	description?: string;
	sections!: DynamicTemplateSectionDto[];
}
export class DynamicTemplateSectionDto extends AbstractDto {
	id!: number;
	name!: string;
	description?: string;
}

export class EmployerDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	name!: string;
	properties!: DynamicProperties;
}
export class CategoryDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	name!: string;
	properties!: DynamicProperties;
}
export class MemberDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	idNumber!: string;
	name!: string;
	surname!: string;
	msisdn?: string;
	emailAddress?: string;
	dateOfBirth!: Date;
	capturedByAgent?: AgentDto;
	dependants!: DependantDto[];
	memberships!: MembershipDto[];
	properties!: DynamicProperties;
}
export class MembershipDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	membershipNumber!: string;
	category!: string;
}


export class DependantDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	relationship!: MemberRelationshipEnum;
	dependantNumber!: number;
	idNumber!: string;
	name!: string;
	surname!: string;
	msisdn!: string;
	emailAddress!: string;
	dateOfBirth!: Date;
	properties!: DynamicProperties;
}


export class DynamicPayloadDto {
	instanceId?: number;
	properties!: DynamicPayloadDto_Property[];
}
export class DynamicPayloadDto_Property {
	propertyId!: number;
	value?: DynamicPayloadDto_PropertyValueSimple | DynamicPayloadDto_PropertyValueList | DynamicPayloadDto_PropertyValueSubPayload;
}
export class DynamicPayloadDto_PropertyValueSimple {
	dynamicPropertyValueType = 'simple';
	value?: string;
}
export class DynamicPayloadDto_PropertyValueList {
	dynamicPropertyValueType = 'list';
	values!: DynamicPayloadDto_PropertyValueSubPayload[];
}
export class DynamicPayloadDto_PropertyValueSubPayload {
	dynamicPropertyValueType = 'subPayload';
	instanceId?: number;
	properties!: DynamicPayloadDto_Property[];
}


export class WorkflowDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	name!: string;
	label!: string;
	description!: string;
	referencePrefix!: string;
	steps!: WorkflowStepDto[];
	availableReadOnlyFields!: WorkflowStepReadOnlyFieldDto[];
	autoAssign!: boolean;
	linkMemberships!: boolean;
	linkToOtherTicketEnabled!: boolean;
	ticketMode!: TicketModeEnum;

	reports!: TicketReportDto[];
	reportColumnTemplates!: TicketReportColumnTemplateDto[];
}
export class WorkflowStepButtonActionDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	workflowStepButton?: WorkflowStepButtonDto;
	actionType!: WorkflowActionTypeEnum;
	orderIndex!: number;
	name?: string;
	emailFrom?: string;
	emailTo?: string;
	emailCc?: string;
	emailBcc?: string;
	emailSubject?: string;
	emailBody?: string;
	smsRecipients?: string;
	smsMessage?: string;
	attachments?: FileUploadDto[];
	movementWorkflowStepId?: number;
	movementWorkflowStepStatusId?: number;
	additionalCommentRequired?: boolean;
}
export class WorkflowStepButtonDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	label!: string;
	statusId!: number;
	dependencyId?: number;
	dependencyValue?: string;
	orderIndex!: number;

	buttonStyle!: ButtonStyleEnum;
	buttonType!: ButtonTypeEnum;
	icon!: string;
	requiredValidForm!: boolean;
	alignment!: ButtonAlignmentEnum;

	actions!: WorkflowStepButtonActionDto[];
}
export class WorkflowStepDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	description!: string;
	label!: string;
	stepOrder!: number;
	slaDurationWarning!: string;
	slaDurationBreach!: string;
	slaDurationEscalation!: string;
	readOnlyFields!: WorkflowStepReadOnlyFieldDto[];
	sections!: WorkflowStepSectionDto[];
	buttons!: WorkflowStepButtonDto[];
	statuses!: WorkflowStepStatusDto[];
	ticketCount?: number;
}
export class WorkflowStepStatusDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	label!: string;
	reportAlias?: string;
	ticketCount?: number;
	ticketCountWithinSla?: number;
	ticketCountNearingSlaLimit?: number;
	ticketCountOutOfSla?: number;
}
export class WorkflowStepSectionDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	label!: string;
	sectionOrder!: number;
	elements!: WorkflowStepSectionElementDto[];
	statusIds!: number[];
}
export class WorkflowStepSectionElementDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	label!: string;
	description!: string;
	dependencyId?: number;
	orderIndex!: number;
	icon?: string;
	dataType!: DynamicValueDataTypeEnum;
	unique!: boolean;
	required!: boolean;
	dependencyValue?: string;
	options!: WorkflowFormOptionDto[];
	regex?: string;
	minValue?: number;
	maxValue?: number;
	errorMessageUnique?: string;
	errorMessageRequired?: string;
	errorMessageRegex?: string;
	errorMessageMinValue?: string;
	errorMessageMaxValue?: string;
	flagForDuplicateTicket?: boolean;
	statusIds!: number[];
}

export class WorkflowStepReadOnlyFieldDto extends AbstractDto {
	dynamicPropertyId!: number;
	group!: string;
	name!: string;
	selected!: boolean;
}
export class WorkflowFormOptionDto extends AbstractDto {
	label!: string;
	value?: string;
	orderIndex!: number;
}

export class TicketUploadPayload {
	fieldProperties!: { [key: number]: string | undefined };
	additionalFiles!: { [key: string]: string | undefined };
	requiredCommunications!: { [key: number]: TicketButtonCommunicationDto };
	additionalCommunications!: TicketButtonCommunicationDto[];
	additionalComment?: string;
	button!: TicketButtonDto;
}

export class TicketDto extends AbstractDto {
	id!: number;
	createdAt?: Date;
	workflowId!: number;
	workflowLabel!: string;
	workflowDescription!: string;
	steps!: TicketStepDto[];
	status!: TicketStatusEnum;
	createdByAgent!: AgentDto;
	member!: MemberDto;
	membership?: MembershipDto;
	dependant!: DependantDto;
	assignedToAgent?: AgentDto;
	currentStepAndStateLabel!: string;
	slaLevel!: TicketSlaLevelEnum;
	timeUntilNextSlaLevel!: string;
	lastActionedAt!: Date;
	relatedToOtherTicket?: TicketDto;
	hasAccess!: boolean;
	ticketUuid!: string;
	ticketMode?: TicketModeEnum;
	ticketReference!: string;
}
export class TicketStepDto extends AbstractDto {
	id!: number;
	label!: string;
	description!: string;
	order!: number;
	isCurrentState!: boolean;
	stateLabel!: string;
	completed!: boolean;
	details!: TicketDetailDto[];
	buttons!: TicketButtonDto[];
	sections!: TicketSectionDto[];
	additionalFiles!: TicketAdditionalFileDto[];
	placeholders!: CommunicationPlaceholders;
	availableAttachments!: { [key: number]: FileUploadDto };
	availableAttachmentsAdditional!: { [key: number]: FileUploadDto };
}

export class TicketAdditionalFileDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	addedByAgent!: AgentDto;
	addedStepId!: number;
	addedStepLabel!: string;
	addedStateId!: number;
	addedStateLabel!: string;
	uploadedByAgent?: AgentDto;
	uploadedAt?: Date;
	uploadedStepId?: number;
	uploadedStepLabel?: string;
	uploadedStateId?: number;
	uploadedStateLabel?: string;
	label!: string;
	uuid?: string;
	isReplaced!: Boolean;
}

export class TicketDetailDto extends AbstractDto {
	id!: number;
	groupLabel!: string;
	label!: string;
	dataType!: DynamicValueDataTypeEnum;
	value?: string;
}
export class TicketButtonDto extends AbstractDto {
	id!: number;
	label!: string;
	icon!: string;
	order!: number;
	style!: ButtonStyleEnum;
	type!: ButtonTypeEnum;
	alignment!: ButtonAlignmentEnum;
	requiredValidForm!: boolean;
	requiredCommunications!: TicketButtonCommunicationDto[];
	additionalCommunications?: TicketButtonCommunicationDto[];
	onClickSubmitForm!: boolean;
	onClickGotoTicketList!: boolean;
	onClickComposeAdditionalCommunication!: boolean;
	onClickCaptureAdditionalComment!: boolean;
	isAdditionalCommentRequired!: boolean;
}
export class TicketSectionDto extends AbstractDto {
	id!: number;
	label!: string;
	order!: number;
	elements!: TicketElementDto[];
}
export class TicketElementDto extends AbstractDto {
	id!: number;
	label!: string;
	description!: string;
	dependencyId?: number;
	dependencyValue?: string;
	order!: number;
	icon?: string;
	dataType!: DynamicValueDataTypeEnum;
	isUnique!: boolean;
	minValue?: number;
	maxValue?: number;
	required!: boolean;
	regex?: string;
	options!: DynamicFormOptionDto[];
	errorMessageUnique?: string;
	errorMessageRequired?: string;
	errorMessageRegex?: string;
	errorMessageMinValue?: string;
	errorMessageMaxValue?: string;
	value?: string;
}

export class TicketButtonCommunicationDto extends AbstractDto {
	id!: number;
	createdAt?: Date;
	actionType!: WorkflowActionTypeEnum;
	type!: CommunicationTypeEnum;
	name?: string;
	emailFrom?: string;
	emailTo?: string;
	emailCc?: string;
	emailBcc?: string;
	emailSubject?: string;
	emailBody?: string;
	smsMsisdn?: string;
	smsMessage?: string;
	attachments?: FileUploadDto[];
	triggeredByAgent?: AgentDto;
}



export class TicketAdditionalCommentDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	workflowStep!: WorkflowStepDto;
	workflowStepStatus!: WorkflowStepStatusDto;
	agent!: AgentDto;
	comment!: string;
}
export class TicketMovementDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	triggeredByAgent!: AgentDto;
	workflowStep!: WorkflowStepDto;
	workflowStepButton?: WorkflowStepButtonDto;
	workflowStepStatus!: WorkflowStepStatusDto;
	assignedToAgent?: AgentDto;
	completed!: boolean;
}
export class TicketHistoryDto extends AbstractDto {
	ticket!: TicketDto;
	movements!: TicketMovementDto[];
	communications!: TicketButtonCommunicationDto[];
	additionalComments!: TicketAdditionalCommentDto[];
	fields!: TicketHistoryCapturedFieldDto[];
}
export class TicketHistoryCapturedFieldDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	agentFullName?: string;
	workflowStepLabel!: string;
	workflowSectionLabel!: string;
	inputLabel!: string;
	inputDescription!: string;
	inputValue?: string;
	dataType!: DynamicValueDataTypeEnum;
}

export class MemberSearchResultListDto extends AbstractDto {
	searchPhrase!: string;
	results!: MemberSearchResultDto[];
	tooOpen!: boolean;
}
export class MemberSearchResultDto extends AbstractDto {
	matchOn!: string;
	member!: MemberDto;
}
export class ResultListDto<T> extends AbstractDto {
	list!: T[];
	totalItems!: number;
	pageIndex!: number;
	pageSize!: number;
}

export class FileUploadDto extends AbstractDto {
	refId?: number;
	uuid!: string;
	fileName!: string;
	name!: string;
	size!: number;
	type!: string;
	selected?: boolean;
}



export class WorkflowRoleDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	workflow!: WorkflowDto;
	name!: string;
	description!: string;
	active!: boolean;
	statuses!: WorkflowRoleStepStatusDto[];
	agents!: AgentLinkDto[];

}
export class WorkflowRoleStepStatusDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	workflowStep!: WorkflowStepDto;
	workflowStepStatus!: WorkflowStepStatusDto;
	type!: WorkflowRoleTypeEnum;
}

export class AgentLinkDto extends AbstractDto {
	agentId!: number;
	agentName!: string;
	agentSurname!: string;
	linked!: boolean;
}



export class BulkUploadSettingDto extends AbstractDto {
	required!: boolean;
	name!: string;
	label!: string;
	description!: string;
	fileType!: string;
}
export class BulkUploadDto extends AbstractDto {
	id?: number;
	createdAt?: Date;
	type?: string;
	agent?: AgentDto;
	status?: BulkUploadStatusEnum;
	files?: BulkUploadFileDto[];
	insertCount?: number;
	updateCount?: number;
	invalidCount?: number;
	failedCount?: number;
}
export class BulkUploadFileDto extends AbstractDto {
	id?: number;
	name!: string;
	agent!: AgentDto;
	status!: BulkUploadStatusEnum;
	uploadedAt!: Date;
	startedAt?: Date;
	completedAt?: Date;
	file!: FileUploadDto;
	lineCount!: number;
	validCount!: number;
	updateCount!: number;
	insertCount!: number;
	failedCount!: number;
	// columnHeaders!: string[];
	// sample!: BulkUploadValueDto[][];
}
// export class BulkUploadValueDto extends AbstractDto {
// 	value?: string;
// 	valid!: Boolean;
// 	message?: string;
// }





export class BulkUploadFileLineDto extends AbstractDto {
	sheetName!: string;
	lineNumber!: number;
	status!: BulkUploadLineStatusEnum;
	columns!: BulkUploadFileCellDto[];
}
export class BulkUploadFileCellDto extends AbstractDto {
	name?: string;
	value?: string;
	propertyId?: number;
	valid!: boolean;
	message?: string;
}










export class Duration {
	years: number = 0;
	months: number = 0;
	days: number = 0;
	hours: number = 0;
	minutes: number = 0;
	seconds: number = 0;
}
export class TicketBundleDto extends AbstractDto {
	agents!: AgentDto[];
	workflows!: WorkflowDto[];
	ticketsToFocusOn!: ResultListDto<TicketDto>;
}
export class TicketReportDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	name?: string;
	description?: string;
	isSummary!: boolean;
	columns!: TicketReportColumnDto[];
	workflow!: WorkflowDto;
}
export class TicketReportColumnDto extends AbstractDto {
	id?: number;
	createdAt?: Date;
	title?: string;
	type?: string;
	value?: number;
	mode?: TicketReportColumnValueTypeModeEnum;
	order?: number;
	parentId?: number;
	subColumns!: TicketReportColumnDto[];
	template?: TicketReportColumnTemplateDto;
	filterOperator?: ReportFilterOperatorEnum;
	filterValue?: string;
	alignment!: TicketReportCellAlignmentEnum;
	dataType!: TicketReportCellDataTypeEnum;

}

export class TicketReportColumnTemplateDto extends AbstractDto {
	key!: string;
	type!: string;
	group1!: string;
	group2?: string;
	name!: string;
	value!: number;
	modes!: { [key: string]: string };
}
export class TicketReportPreviewRowDto extends AbstractDto {
	cells!: string[];
}

export class NotificationBulkDto {
	id?: number;
	createdAt?: Date;
	createdByAgent?: AgentDto;
	status?: BulkNotificationStatusEnum;
	channel?: CommunicationTypeEnum;
	subject?: String;
	body?: String;
	nextRunDate?: Date;
	deliveryReport?: Boolean;
}

export class NotificationBulkFilterDto {
	id?: number;
	notificationBulk?: NotificationBulkDto;
	propertyId!: number;
	propertyName!: string;
	operator!: FilterOperatorEnum;
	dataType!: DynamicValueDataTypeEnum;
	value!: any;
}

export class NotificationBulkTriggerDto {
	id?: number;
	notificationBulk?: NotificationBulkDto;
	triggerName!: string;
	triggerDescription!: string;
	triggerType!: CommunicationTriggerTypeEnum;
	frequency!: CommunicationFrequencyTypeEnum;
	reminderBefore!: CommunicationReminderBeforeEnum;
	reminderBeforeValue!: number;
	triggerTime!: string | undefined;
	description?: string;
}

export class NotificationBulkLogDto {
	id!: number;
	createdAt!: Date;
	notificationBulk!: NotificationBulkDto;
	channel!: CommunicationTypeEnum;
	subject!: String;
	body!: String;
	triggerType!: CommunicationTriggerTypeEnum;
	runDate!: Date;
	nextRunDate!: Date;
	eligibleMemberCount?: number;
}

export class BulkNotificationDto {
	bulk?: NotificationBulkDto;
	trigger?: NotificationBulkTriggerDto;
	filters?: NotificationBulkFilterDto[];
	filterCount?: number;
	expanded?: boolean;
	attachments?: FileUploadDto[];
}
export class AiMessageDto {
	when!: Date;
	duration!: number;
	direction?: 'Sent' | 'Received';
	message!: string;
	messageHtml!: string;
}



export class NotificationBulkReportDto {
	name!: string;
	agent!: AgentDto;
	createdAt!: Date;
	sentAt!: Date;
	channel!: CommunicationTypeEnum;
	sendDuration!: number;
	metrics!: Record<BulkNotificationMetricEnum, string>;
	attachments!: FileUploadDto[];
	trigger!: NotificationBulkTriggerDto;
	filters!: NotificationBulkFilterDto[];
	subject!: string;
	body!: string;
}
export class HierarchyDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	name!: string;
	description!: string;
	subHierarchies!: HierarchyDto[];
}

export enum BulkNotificationMetricEnum {
	Sent = "Sent",
    Accepted = "Accepted",
    AdminBounce = "AdminBounce",
    BlockBounce = "BlockBounce",
    Bounce = "Bounce",
    Clicked = "Clicked",
    Delayed = "Delayed",
    DelayedFirst = "DelayedFirst",
    Delivered = "Delivered",
    DeliveredFirst = "DeliveredFirst",
    DeliveredSubsequent = "DeliveredSubsequent",
    GenerationFailed = "GenerationFailed",
    GenerationRejection = "GenerationRejection",
    HardBounce = "HardBounce",
    InbandBounce = "InbandBounce",
    InitialRendered = "InitialRendered",
    Injected = "Injected",
    NonPrefetchedInitialRendered = "NonPrefetchedInitialRendered",
    NonPrefetchedRendered = "NonPrefetchedRendered",
    NonPrefetchedUniqueConfirmedOpened = "NonPrefetchedUniqueConfirmedOpened",
    NonPrefetchedUniqueInitialRendered = "NonPrefetchedUniqueInitialRendered",
    NonPrefetchedUniqueRendered = "NonPrefetchedUniqueRendered",
    OutOfBandBounce = "OutOfBandBounce",
    PolicyRejection = "PolicyRejection",
    Rejected = "Rejected",
    Rendered = "Rendered",
    SoftBounce = "SoftBounce",
    SpamComplaint = "SpamComplaint",
    Targeted = "Targeted",
    UndeterminedBounce = "UndeterminedBounce",
    UniqueClicked = "UniqueClicked",
    UniqueConfirmedOpened = "UniqueConfirmedOpened",
    UniqueInitialRendered = "UniqueInitialRendered",
    UniqueRendered = "UniqueRendered",
    Unsubscribe = "Unsubscribe",
    TotalDeliveryTimeFirst = "TotalDeliveryTimeFirst",
    TotalDeliveryTimeSubsequent = "TotalDeliveryTimeSubsequent",
    TotalMsgVolume = "TotalMsgVolume",
    AcceptedRate = "AcceptedRate",
    AdminBounceRate = "AdminBounceRate",
    AvgDeliveryTimeFirst = "AvgDeliveryTimeFirst",
    AvgDeliveryTimeSubsequent = "AvgDeliveryTimeSubsequent",
    AvgMsgSize = "AvgMsgSize",
    BlockBounceRate = "BlockBounceRate",
    BounceRate = "BounceRate",
    ClickThroughRate = "ClickThroughRate",
    CountInbox = "CountInbox",
    CountSpam = "CountSpam",
    DelayedRate = "DelayedRate",
    HardBounceRate = "HardBounceRate",
    OpenRate = "OpenRate",
    RejectedRate = "RejectedRate",
    SoftBounceRate = "SoftBounceRate",
    SpamComplaintRate = "SpamComplaintRate",
    UndeterminedBounceRate = "UndeterminedBounceRate",
    UnsubscribeRate = "UnsubscribeRate",
}

export class NotificationBulkEventsDto {
	name!: string;
	surname!: string;
	to!: string;

	accepted!: number;
	delivery!: number;
	open!: number;
	click!: number;
	bounce!: number;
	spamComplaint!: number;
	policyRejection!: number;

	acceptedAt!: Date;
	deliveryAt!: Date;
	openedAt!: Date[];
	clickedAt!: Date[];
	bouncedAt!: Date;
	spamComplaintAt!: Date;
	policyRejectionAt!: Date;
}

//export type FilterOperatorEnum = "Equal" | "LessThan" | "GreaterThan" | "LessThanEqual" | "GreaterThanEqual";
export enum FilterOperatorEnum {
	Equal = "Equal",
	LessThan = "LessThan",
	GreaterThan = "GreaterThan",
	LessThanEqual = "LessThanEqual",
	GreaterThanEqual = "GreaterThanEqual",
}

export type CommunicationReminderBeforeEnum = 'Day' | 'Week' | 'Month';
export type CommunicationFrequencyTypeEnum = 'FirstDayOfMonth' | 'FirstWorkingDayOfMonth' | 'LastDayOfMonth' | 'LastWorkingDayOfMonth' | 'Daily' | 'Weekly' | 'Fortnight' | 'Monthly' | 'Quarterly' | 'BiAnnually' | 'Annually';
export type CommunicationTriggerTypeEnum = 'OnceOff' | 'DateOfBirth' | 'PolicyRenewalReminder' | 'Recurring';
export type BulkNotificationStatusEnum = 'Pending' | 'Disabled' | 'Active';

export type CommunicationPlaceholders = { [key: string]: string };
export type DynamicProperties = { [key: string]: string };
export type RolePermissionEnum = 'MemberAdd' | 'MemberEdit' | 'MemberView' | 'MemberSearch' | 'MembersBulkImport' | 'Ticket' | 'TicketAdmin' | 'TicketReportList' | 'TicketReportRun' | 'TicketReportAddEdit' | 'CommunicationSend' | 'CommunicationScheduledAutomated' | 'CommunicationLog' | 'AgentAdd' | 'AgentEdit' | 'AgentView' | 'AgentList' | 'EntityView' | 'EntityEdit' | 'EntityAdd' | 'EntityList' | 'DynamicPropertyEdit' | 'DynamicPropertyView' | 'WorkflowAdd' | 'WorkflowView' | 'WorkflowEdit' | 'WorkflowManageRoles' | 'RoleAdd' | 'RoleEdit' | 'RoleView' | 'RoleList' | 'PermissionManage';
export type RolePermissionGroupEnum = 'Member' | 'Agent' | 'Ticket' | 'Communication' | 'Entity' | 'Configuration';

export type AgentStatusEnum = 'Active' | 'Blocked' | 'Suspended';
export type DynamicValueDataTypeEnum = 'Text' | 'TextArea' | 'Boolean' | 'DropDownSingle' | 'Number' | 'PastDate' | 'FutureDate' | 'Date' | 'Time' | 'PastDateTime' | 'FutureDateTime' | 'File' | 'Password' | 'Email' | 'Msisdn' | 'SetOfRecords' | 'SelectFromRecords' | 'RequiredCheckbox' | 'Hierarchy';
export type DynamicTypeEnum = 'Dynamic' | 'Field';
export type OtpLookupResultEnum = 'Valid' | 'Invalid' | 'Expired' | 'MaxAttemptsReached' | 'AlreadyUsed';
export type MemberRelationshipEnum = 'Spouse' | 'Child' | 'Ward' | 'Parent' | 'Sibling' | 'Other';
export type DynamicEntityTypeEnum = 'AgentAdmin' | 'AgentFao' | 'AgentUnderwriter' | 'Member' | 'Dependant';
export type WorkflowActionTypeEnum = 'SplitTicketGroup' | 'RequiredCommunication' | 'AdditionalCommunication' | 'Movement' | 'CancelTicket' | 'CloseTicket' | 'CancelForm' | 'SaveForm' | 'AdditionalComment';
export type TicketStatusEnum = 'Open' | 'Cancelled' | 'Closed';
export type TicketSlaLevelEnum = 'Good' | 'Warning' | 'Critical' | 'Overdue';

export type ButtonTypeEnum = 'Primary' | 'Default' | 'Dashed' | 'Text' | 'Link';
export type ButtonStyleEnum = 'Danger' | 'Ghost' | 'Default';
export type ButtonAlignmentEnum = 'Left' | 'Right';

export type CommunicationTypeEnum = 'Email' | 'Sms';
export type WorkflowRoleTypeEnum = 'ViewOnly' | 'ListAndView' | 'ListViewAndProcess';
export type BulkUploadStatusEnum = 'Pending' | 'Processing' | 'Completed' | 'Failed' | 'Rejected'
export type ReportFilterOperatorEnum = 'Equals' | 'NotEquals' | 'GreaterThan' | 'LessThan' | 'GreaterThanOrEqual' | 'LessThanOrEqual';

export type TicketModeEnum = 'Claim' | 'Complaint';
export type TicketReportColumnValueTypeModeEnum = 'Value' | 'When' | 'Who' | 'Captured';


export type BulkUploadLineStatusEnum = 'Invalid' | 'Inserted' | 'Updated' | 'Failed';

export type TicketReportCellAlignmentEnum = 'Left' | 'Center' | 'Right';
export type TicketReportCellDataTypeEnum = 'Text' | 'Number' | 'Currency';
